module.exports = __webpack_public_path__ + "static/media/Accenture.d58a9d0c.png";